export default {"src":"/_next/static/media/wave.86e41c67.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};